module.exports = __webpack_public_path__ + "media/images/flags/ax-d7a83733193d2e4c8c2dba3f2d6e5a9f.svg";